export const TOUCH_TARGET_PX = 44;

export const touchTargetSx = {
  [`@media (hover: none)`]: {
    minHeight: TOUCH_TARGET_PX,
    minWidth: TOUCH_TARGET_PX,
  },
};

export const touchHitAreaSx = {
  position: 'relative',
  '&::after': {
    content: '""',
    position: 'absolute',
    top: '50%',
    left: 0,
    right: 0,
    transform: 'translateY(-50%)',
    ...touchTargetSx,
  },
} as const;
